import {PageName, PAGES, PROD_HOST} from '@/constants';

export function getCanonicalUrl(pageName: PageName) {
	return `${PROD_HOST}${PAGES[pageName].href}`;
}
